import { format } from 'date-fns/format';
import { parseISO } from 'date-fns/parseISO';

export type FormatDateToMonthAndDayOptions = {
  monthFormat?: 'long' | 'short' | 'shortExceptJuneJuly';
  /** @deprecated use monthFormat instead */
  abbreviatedMonth?: boolean;
};

/**
 *
 * @param dateString - the date string to format
 * @param options - optional arguments
 * @returns dateString formatted to month and day.
 * @throws if parsed date string produces an "Invalid Date"
 *
 * @example
 * ```ts
 * formatDateToMonthAndDay('2000-01-01') // January 1
 * formatDateToMonthAndDay('2000-01-01', { monthFormat: 'long' }) // January 1
 * formatDateToMonthAndDay('2000-01-01', { monthFormat: 'short' }) // Jan 1
 * formatDateToMonthAndDay('2000-06-01', { monthFormat: 'short' }) // Jun 1
 * formatDateToMonthAndDay('2000-01-01', { monthFormat: 'shortExceptJuneJuly' }) // Jan 1
 * formatDateToMonthAndDay('2000-06-01', { monthFormat: 'shortExceptJuneJuly' }) // June 1
 * ```
 */
export function formatDateToMonthAndDay(
  dateString: string,
  options?: FormatDateToMonthAndDayOptions
) {
  const parsed = parseISO(dateString);

  if (parsed.toString() === 'Invalid Date') {
    throw new Error('invalid date');
  }

  if (options?.abbreviatedMonth || options?.monthFormat === 'short') {
    return format(parsed, 'MMM d');
  }

  if (options?.monthFormat === 'shortExceptJuneJuly') {
    if (parsed.getMonth() === 5 || parsed.getMonth() === 6) {
      return format(parsed, 'MMMM d');
    }

    return format(parsed, 'MMM d');
  }

  return format(parsed, 'MMMM d');
}
